import { Typography } from '@/components/atoms';
import { cn } from '@/lib/utils/tailwind';

type HeaderBannerProps = {
  title?: string;
  subTitle?: string;
  bgColor?: string;
  className?: string;
};

const TextBanner = ({ title, subTitle, bgColor }: HeaderBannerProps) => {
  return (
    <div
      className="flex flex-col pointer-events-none min-h-96 w-full text-center justify-center items-center"
      style={bgColor ? { backgroundColor: bgColor } : undefined}
    >
      {title && (
        <div>
          <Typography.Heading
            variant={'h1'}
            className={cn([
              'hero-text-display',
              'hero-box-decoration',
              'px-2',
              'py-2',
              'w-fit',
              'bg-(--hero-text-background)',
              'hero-text-overflow',
              'hero-text-hyphenate',
            ])}
          >
            {title}
          </Typography.Heading>
        </div>
      )}
      {subTitle && (
        <div>
          <Typography.Text
            variant={'paragraph'}
            size={'lg'}
            className={cn([
              'hero-text-display',
              'hero-box-decoration',
              'px-1',
              'py-1',
              'w-fit',
              'hero-text-style',
              'bg-(--hero-text-background)',
            ])}
          >
            {subTitle}
          </Typography.Text>
        </div>
      )}
    </div>
  );
};

export { TextBanner };
